import keyMirror from 'keymirror';

export default keyMirror({
  RECIEVE_PACK: null,
  RECIEVE_PACK_ERROR: null,
  RECIEVE_PACKS: null,
  RECIEVE_PACKS_ERROR: null,
  RECIEVE_VARIANTS: null,
  RECIEVE_VARIANTS_ERROR: null,
  RECIEVE_ORDER: null,
  RECIEVE_ORDER_ERROR: null,
  SELECT_PACK: null,
  SELECT_VARIANT: null,
  DESELECT_ORDER: null,
  GET_CART_ERROR: null,
  PROCESS_PAKOWANIE: null,
  PROCESS_PAKOWANIE_ERROR: null,
  RECIEVE_MULTIPACK: null,
  RECIEVE_MULTIPACK_ERROR: null,
  CONFIRM_DONE: null,
  ADD_PACKAGE: null,
  ADD_PACKAGE_ERROR: null,
  ADD_DELIVERY: null,
  ADD_DELIVERY_ERROR: null,
  PRINT_LABEL: null,
  PRINT_LABEL_ERROR: null,
  PRINT_INVOICE: null,
  PRINT_INVOICE_ERROR: null,
  SCAN_PRODUCT: null,
  SCAN_PRODUCT_DONE: null
});



// WEBPACK FOOTER //
// ./src/constants/PackConstants.js